import DynamicForm from "../../../../components/FormElements/DynamicForm";
import * as Yup from 'yup';
import { Col, Row } from "antd";
import logo from '../../../../assets/images/logo.png'
import AuthLayout from "../../../../components/Layout/AuthLayout";
import './style.css'
import Button from "../../../../components/FormElements/Button";
import { Link, useNavigate } from "react-router-dom";
import { FaEnvelope, FaEye } from "react-icons/fa";
import { useEffect } from "react";
import useAuthApi from "../../../../config/hooks/api/auth/useAuthApi";
import { useDispatch } from "react-redux";
import { setAppLoading, setError, setMessage } from "../../../../store/common/generalSlice";


const ResetPassword = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { resetPassword } = useAuthApi()

  // Define the form configuration
  const form = {
    name: 'resetPasswordForm',
    formFields: [
      {
        name: 'password',
        type: 'password',
        label: { value: 'Enter Password', style: '', classes: '' },
        placeholder: 'Password',
        width: { md: 24, sm: 24, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <FaEnvelope />
      },
      {
        name: 'confirmPassword',
        type: 'password',
        label: { value: 'Re-enter Password', style: '', classes: '' },
        placeholder: 'Password',
        width: { md: 24, sm: 24, xs: 24 },
        component: null,
        classes: 'icon-primary',
        icon: <FaEye />
      },
    ],
    formValidation: {
      password: Yup.string()
      .required('Password is required')
      .min(8, 'Password should be 8 characters long')
      .max(20, 'Password should not exceed 20 characters'),
      // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      // .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    },
  }

  const handleSubmit = async (values) => {
    try {
      if (!values || Object.keys(values).length !== 2) {
        dispatch(setError('Fields should not be empty'))
        return
      }

      const user = JSON.parse(localStorage.getItem('tempUser'))
      if (!user || user.type !== 4) {
        localStorage.removeItem('tempUser')
        navigate('/login')
        return
      }

      const { password } = values
      const { email } = user

      dispatch(setAppLoading(true))

      const response = await resetPassword({ email, password })
      if (response) {
        dispatch(setMessage(response?.data?.message))
        dispatch(setAppLoading(false))

        localStorage.removeItem('tempUser')
        navigate('/login')
      }
    } catch (error) {
      console.error("Error:", error);
      dispatch(setAppLoading(false))
    }
  };

  const submitForm = () => {
    document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
  }

  const validateRoute = () => {
    const user = JSON.parse(localStorage.getItem('tempUser'))
    if (!user || user?.type !== 4) {
      navigate('/login')
    }
  }

  useEffect(() => {
    validateRoute()
  }, [])


  return (
    <AuthLayout>
      <Row className="flex justify-center reset-password-screen custom-card-boxshadow px-4 py-5 rounded-md">
        <Col xs={24} sm={18} md={18} className="form-section">
          <img src={logo} alt='logo' className="img-fluid logo mb-12" />
          <h4 className="heading-4 font-bold mb-4">Reset Password</h4>
          <p className="text-slate-500 mb-6 text-center">Set the new password for your account</p>
          <DynamicForm onSubmit={handleSubmit} form={form} />
          <div className="flex justify-start w-full mt-2 mb-6">
            <Button.Basic
              onClick={submitForm}
              disabled={false}
              icon={null}
              loading={false}
              type="primary"
              size='medium'
              text='Update'
              className='btn-primary md:w-fit sm:w-fit w-full'
            />
          </div>
          <div className="text-slate-300 dashed-line w-full mb-3"></div>
          <Row className="mb-3 w-full">
            <Col md={16} sm={16} xs={24} className="md:text-left sm:text-left text-center">
              <div className="md:text-left sm:text-left text-center">
                <small className="text-slate-400">Back to</small>
                <Link to='/login' className="ml-1 font-bold">Login</Link>
              </div>
            </Col>
          </Row>
          <div className="text-slate-300 dashed-line w-full mb-6"></div>
        </Col>
      </Row>
    </AuthLayout>
  );
};

export default ResetPassword;
